import fetch from 'node-fetch';
import utils from "../../universal/utils";

export const GUARD_LOADING = 'GUARD_LOADING';
export const GUARD_ERROR = 'GUARD_ERROR';
export const GUARD_DEVICES_LOADED = 'GUARD_DEVICES_LOADED';
export const GUARD_DEVICE_LOADED = 'GUARD_DEVICE_LOADED';
export const GUARD_VERSION_DISTRIBUTION_LOADED = 'GUARD_VERSION_DISTRIBUTION_LOADED';
export const GUARD_RELEASES_LOADED = 'GUARD_RELEASES_LOADED';
export const GUARD_CLEAR_DEVICE = 'GUARD_CLEAR_DEVICE';

const basePath = utils.getEdgeBasePath();

function fetchAdmin(url, options = {}) {
  return fetch(url, { ...options, credentials: "include" });
}

async function parseAdminResponse(response) {
  let data = {};
  try {
    data = await response.json();
  } catch (error) {
    if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    throw error;
  }
  if (!response.ok || data?.ok === false) {
    throw new Error(data?.error || data?.err || data?.message || `HTTP ${response.status}`);
  }
  return data;
}

export const fetchGuardDevices = (search) => {
  return async (dispatch) => {
    dispatch({ type: GUARD_LOADING });
    try {
      const url = search
        ? `${basePath}/api/v7/admin/guard/devices?search=${encodeURIComponent(search)}`
        : `${basePath}/api/v7/admin/guard/devices`;
      const response = await fetchAdmin(url);
      const data = await parseAdminResponse(response);
      dispatch({ type: GUARD_DEVICES_LOADED, payload: data.devices || [] });
    } catch (error) {
      console.error('Error fetching guard devices:', error);
      dispatch({ type: GUARD_ERROR, payload: error.message });
    }
  };
};

export const fetchGuardDevice = (deviceId) => {
  return async (dispatch) => {
    if (!deviceId) return;
    dispatch({ type: GUARD_LOADING });
    try {
      const response = await fetchAdmin(`${basePath}/api/v7/admin/guard/devices/${deviceId}`);
      const data = await parseAdminResponse(response);
      dispatch({
        type: GUARD_DEVICE_LOADED,
        payload: { device: data.device, events: data.events || [] },
      });
    } catch (error) {
      console.error('Error fetching guard device:', error);
      dispatch({ type: GUARD_ERROR, payload: error.message });
    }
  };
};

export const fetchVersionDistribution = () => {
  return async (dispatch) => {
    try {
      const response = await fetchAdmin(`${basePath}/api/v7/admin/guard/version-distribution`);
      const data = await parseAdminResponse(response);
      dispatch({ type: GUARD_VERSION_DISTRIBUTION_LOADED, payload: data.versions || [] });
    } catch (error) {
      console.error('Error fetching version distribution:', error);
    }
  };
};

export const fetchGuardReleases = () => {
  return async (dispatch) => {
    try {
      const response = await fetchAdmin(`${basePath}/api/v7/admin/guard/releases`);
      const data = await parseAdminResponse(response);
      dispatch({
        type: GUARD_RELEASES_LOADED,
        payload: {
          releases: data.releases || [],
          policy: data.policy || null,
          envOverrides: data.envOverrides || {},
        },
      });
    } catch (error) {
      console.error('Error fetching guard releases:', error);
      dispatch({ type: GUARD_ERROR, payload: error.message });
    }
  };
};

export const saveGuardReleasePolicy = ({ latestVersion, minimumVersion }) => {
  return async (dispatch) => {
    try {
      const response = await fetchAdmin(`${basePath}/api/v7/admin/guard/release-policy`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ latestVersion, minimumVersion }),
      });
      await parseAdminResponse(response);
      dispatch(fetchGuardReleases());
    } catch (error) {
      console.error('Error saving guard release policy:', error);
      dispatch({ type: GUARD_ERROR, payload: error.message });
    }
  };
};

export const revokeGuardDevice = (deviceId) => {
  return async (dispatch) => {
    try {
      const response = await fetchAdmin(
        `${basePath}/api/v7/admin/guard/devices/${deviceId}/revoke`,
        { method: 'POST' }
      );
      await parseAdminResponse(response);
      dispatch(fetchGuardDevices());
    } catch (error) {
      console.error('Error revoking guard device:', error);
      dispatch({ type: GUARD_ERROR, payload: error.message });
    }
  };
};

export const clearSelectedDevice = () => ({
  type: GUARD_CLEAR_DEVICE,
});
